import {
	Dialog,
	Portal,
	Flex,
	Box,
	Stack,
	Text,
	Separator,
	Card,
	IconButton,
	Button,
} from '@welbe/design-system';
import { FiUserPlus, FiUsers, FiX } from 'react-icons/fi';
import { tokens } from '@welbe/web-design-system';

type ModalAddEmployeeProps = {
	open?: boolean;
	onOpen: () => void;
	onClose: () => void;
	onAddSingleEmployee: () => void;
	onAddMultipleEmployees: () => void;
};

const dialogOptions = [
	{
		id: 'single',
		label: 'Un solo colaborador',
		description: 'Agrega un colaborador directamente en la plataforma',
		icon: <FiUserPlus color={tokens.color_primary} size="1.5rem" />,
	},
	{
		id: 'multiple',
		label: 'Múltiples colaboradores via CSV',
		description:
			'Llena el template y cárgalo para crear múltiples colaboradores',
		icon: <FiUsers color={tokens.color_primary} size="1.5rem" />,
	},
];

export const ModalAddEmployee = ({
	open,
	onOpen,
	onClose,
	onAddSingleEmployee,
	onAddMultipleEmployees,
}: ModalAddEmployeeProps) => {
	return (
		<Dialog.Root
			open={open}
			onOpenChange={(state: any) => !state.open && onClose()}
			color="#64778F"
			closeOnEscape={false}
			closeOnInteractOutside={false}
		>
			<Dialog.Trigger asChild>
				<Button
					size="sm"
					variant="outline"
					backgroundColor="white"
					_hover={{ backgroundColor: 'inherit' }}
					onClick={() => onOpen()}
				>
					Alta de colaborador <FiUserPlus />
				</Button>
			</Dialog.Trigger>
			<Portal>
				<Dialog.Backdrop />
				<Dialog.Positioner>
					<Dialog.Content backgroundColor="#FAFCFD">
						<Dialog.Header padding="1.5rem">
							<Dialog.Title>
								<Flex gap="1rem">
									<Box
										backgroundColor="blue.900"
										width="3rem"
										height="3rem"
										borderRadius="l3"
										justifyContent="center"
										alignItems="center"
										display="flex"
									>
										<FiUserPlus color="white" size="1.5rem" />
									</Box>
									<Stack gap="0">
										<Text fontSize="1rem" lineHeight="1.5rem">
											Añadir colaboradores
										</Text>
										<Text
											fontSize="14px"
											fontWeight="normal"
											lineHeight="1.25rem"
											color="#64778F"
										>
											Elige como añadir colaboradores
										</Text>
									</Stack>
								</Flex>
							</Dialog.Title>
						</Dialog.Header>
						<Separator />
						<Dialog.Body
							padding="1.5rem"
							gap="1rem"
							display="flex"
							flexDirection="column"
						>
							{dialogOptions.map((option) => (
								<Card.Root
									key={option.id}
									cursor="pointer"
									role="button"
									backgroundColor="white"
									_hover={{ borderColor: 'blue.900' }}
									onClick={() =>
										option.id === 'single'
											? onAddSingleEmployee()
											: onAddMultipleEmployees()
									}
								>
									<Card.Body padding="0.75rem 1rem">
										<Flex gap="1rem" color="#64778F">
											{option.icon}
											<Stack gap="0.5rem">
												<Text
													fontSize="1rem"
													lineHeight="1.5rem"
													fontWeight="600"
												>
													{option.label}
												</Text>
												<Text
													fontSize="14px"
													fontWeight="normal"
													lineHeight="1.25rem"
												>
													{option.description}
												</Text>
											</Stack>
										</Flex>
									</Card.Body>
								</Card.Root>
							))}
						</Dialog.Body>
						<Dialog.CloseTrigger asChild>
							<IconButton size="xs" variant="ghost">
								<FiX />
							</IconButton>
						</Dialog.CloseTrigger>
					</Dialog.Content>
				</Dialog.Positioner>
			</Portal>
		</Dialog.Root>
	);
};
